var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-points-container"},[_vm._m(0),_c('div',{staticClass:"auth-content"},[(!_vm.isAuthenticated)?_c('login-form'):_vm._e(),(_vm.isAuthenticated)?_c('user-points'):_vm._e()],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-text"},[_c('h1',[_vm._v(" Seja bem vindo ao "),_c('br'),_vm._v(" nosso Clube! ")])])
}]

export { render, staticRenderFns }